/*
 * Habitual Cart Drawer — client wiring.
 * Rendered DOM and Liquid-derived config live on the section; this script
 * is loaded with defer so it never blocks HTML parsing. Initial /cart.js
 * fetch is deferred to idle time so it does not contend with LCP assets.
 */
(function () {
  function init() {
    var root = document.querySelector('.cdh-root');
    if (!root) return;

    var expireMin = parseInt(root.getAttribute('data-expire-min') || '60', 10) || 60;
    var sectionId = root.getAttribute('data-section-id') || '';
    var shipEnabled   = root.getAttribute('data-ship-enabled') === '1';
    var shipThreshold = parseInt(root.getAttribute('data-ship-threshold') || '0', 10) || 0;
    var shipMsgRem    = root.getAttribute('data-ship-msg-remaining') || 'Lägg till {diff} för fri frakt';
    var shipMsgDone   = root.getAttribute('data-ship-msg-complete') || 'Grattis! Du har fri frakt 🎉';

    var itemsEl        = root.querySelector('[data-cdh-items]');
    var emptyEl        = root.querySelector('[data-cdh-empty]');
    var footerEl       = root.querySelector('[data-cdh-footer]');
    var totalEl        = root.querySelector('[data-cdh-total]');
    var discountRow    = root.querySelector('[data-cdh-discount-row]');
    var discountTitle  = root.querySelector('[data-cdh-discount-title]');
    var discountAmount = root.querySelector('[data-cdh-discount-amount]');
    var upsellEl       = root.querySelector('[data-cdh-upsell]');
    var upsellText     = root.querySelector('[data-cdh-upsell-text]');
    var bumperEl     = root.querySelector('[data-cdh-bumper]');
    var bumperCards  = bumperEl ? bumperEl.querySelectorAll('[data-cdh-bumper-card]') : [];
    var timerEl        = root.querySelector('[data-cdh-timer]');
    var timerBanner    = root.querySelector('[data-cdh-banner]');
    var shippingEl     = root.querySelector('[data-cdh-shipping]');
    var shippingText   = root.querySelector('[data-cdh-shipping-text]');
    var shippingFill   = root.querySelector('[data-cdh-shipping-fill]');

    var TIERS = [
      { qty: 2, pct: 10 },
      { qty: 3, pct: 15 },
      { qty: 4, pct: 20 },
      { qty: 5, pct: 25 }
    ];

    var EXPIRE_MIN = expireMin;
    var LS_KEY = 'cdh_cart_started_at';

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function money(cents) {
      var num = (Math.round(cents) / 100);
      var s = num.toFixed(2).replace('.', ',');
      s = s.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
      return s + ' kr';
    }

    function open() {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cdh-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    function startTimerIfNotRunning() {
      if (!localStorage.getItem(LS_KEY)) {
        localStorage.setItem(LS_KEY, String(Date.now()));
      }
    }
    function clearTimer() {
      localStorage.removeItem(LS_KEY);
      if (timerEl) timerEl.textContent = EXPIRE_MIN + ':00';
      if (timerBanner) timerBanner.classList.remove('is-expired');
    }
    function tickTimer() {
      var started = parseInt(localStorage.getItem(LS_KEY) || '0', 10);
      if (!started) {
        if (timerEl) timerEl.textContent = EXPIRE_MIN + ':00';
        return;
      }
      var elapsed = Math.floor((Date.now() - started) / 1000);
      var remaining = Math.max(0, (EXPIRE_MIN * 60) - elapsed);
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      if (timerEl) {
        timerEl.textContent = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
      }
      if (remaining === 0 && timerBanner) {
        timerBanner.classList.add('is-expired');
      }
    }
    setInterval(tickTimer, 1000);
    tickTimer();

    function render(cart) {
      if (!cart || !cart.items || cart.items.length === 0) {
        emptyEl.hidden = false;
        Array.prototype.slice.call(itemsEl.querySelectorAll('.cdh-item')).forEach(function (n) { n.remove(); });
        footerEl.hidden = true;
        clearTimer();
        return;
      }
      emptyEl.hidden = true;
      footerEl.hidden = false;
      startTimerIfNotRunning();

      var html = cart.items.map(function (item) {
        var compareAt = item.original_line_price > item.final_line_price
          ? '<s>' + esc(money(item.original_line_price)) + '</s>'
          : '';
        var variantLine = '';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          variantLine = '<p class="cdh-item-variant">' + esc(item.variant_title) + '</p>';
        } else if (item.product_type) {
          variantLine = '<p class="cdh-item-variant">' + esc(item.product_type) + '</p>';
        }
        var img = item.image
          ? '<img src="' + esc(item.image.replace('.jpg', '_200x.jpg').replace('.png', '_200x.png').replace('.webp', '_200x.webp')) + '" alt="' + esc(item.product_title) + '" loading="lazy">'
          : '';
        return ''
          + '<div class="cdh-item" data-cdh-line-key="' + esc(item.key) + '">'
          +   '<div class="cdh-item-img">' + img + '</div>'
          +   '<div class="cdh-item-body">'
          +     '<p class="cdh-item-title">' + esc(item.product_title) + '</p>'
          +     variantLine
          +     '<div class="cdh-qty">'
          +       '<button type="button" class="cdh-qty-btn" data-cdh-dec aria-label="Minska antal">\u2212</button>'
          +       '<span class="cdh-qty-value">' + item.quantity + '</span>'
          +       '<button type="button" class="cdh-qty-btn" data-cdh-inc aria-label="Öka antal">+</button>'
          +     '</div>'
          +   '</div>'
          +   '<div class="cdh-item-right">'
          +     '<button type="button" class="cdh-remove" data-cdh-remove aria-label="Ta bort ' + esc(item.product_title) + '">'
          +       '<svg viewBox="0 0 18 18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
          +         '<path d="M3 5h12M7 5V3.5A1.5 1.5 0 0 1 8.5 2h1A1.5 1.5 0 0 1 11 3.5V5M5 5l.8 10a2 2 0 0 0 2 1.8h2.4a2 2 0 0 0 2-1.8L13 5"/>'
          +       '</svg>'
          +     '</button>'
          +     '<span class="cdh-item-price">'
          +       compareAt
          +       esc(money(item.final_line_price))
          +     '</span>'
          +   '</div>'
          + '</div>';
      }).join('');

      Array.prototype.slice.call(itemsEl.querySelectorAll('.cdh-item')).forEach(function (n) { n.remove(); });
      itemsEl.insertAdjacentHTML('beforeend', html);

      totalEl.textContent = money(cart.total_price);

      var discountTitleText = '';
      if (cart.total_discount > 0) {
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
          for (var di = 0; di < cart.cart_level_discount_applications.length; di++) {
            var app = cart.cart_level_discount_applications[di];
            if (app && app.title && String(app.title).trim()) {
              discountTitleText = String(app.title).trim();
              break;
            }
          }
        }
        if (!discountTitleText && cart.items) {
          for (var li = 0; li < cart.items.length; li++) {
            var lineDiscounts = cart.items[li].discounts;
            if (lineDiscounts && lineDiscounts.length) {
              for (var dj = 0; dj < lineDiscounts.length; dj++) {
                var d = lineDiscounts[dj];
                if (d && d.title && String(d.title).trim() && d.amount > 0) {
                  discountTitleText = String(d.title).trim();
                  break;
                }
              }
              if (discountTitleText) break;
            }
          }
        }
      }
      var totalQty = cart.item_count || 0;
      if (totalQty >= 2 && discountTitleText && cart.total_discount > 0) {
        discountRow.hidden = false;
        discountTitle.textContent = discountTitleText;
        discountAmount.textContent = '-' + money(cart.total_discount);
      } else {
        discountRow.hidden = true;
        discountTitle.textContent = '';
        discountAmount.textContent = '';
      }

      if (shipEnabled && shippingEl && shippingText && shippingFill && shipThreshold > 0) {
        var total = cart.total_price || 0;
        if (total >= shipThreshold) {
          shippingEl.classList.add('is-complete');
          shippingText.innerHTML = shipMsgDone;
          shippingFill.style.width = '0%';
        } else {
          shippingEl.classList.remove('is-complete');
          var diff = shipThreshold - total;
          var diffHtml = '<strong>' + esc(money(diff)) + '</strong>';
          shippingText.innerHTML = shipMsgRem.replace('{diff}', diffHtml);
          var pct = Math.max(0, Math.min(100, (total / shipThreshold) * 100));
          shippingFill.style.width = (100 - pct).toFixed(1) + '%';
        }
        shippingEl.hidden = false;
      }

      if (upsellEl && upsellText) {
        var nextTier = null;
        for (var ti = 0; ti < TIERS.length; ti++) {
          if (totalQty < TIERS[ti].qty) { nextTier = TIERS[ti]; break; }
        }
        if (totalQty === 0) {
          upsellEl.hidden = true;
        } else if (nextTier) {
          var diff = nextTier.qty - totalQty;
          upsellText.innerHTML = 'Lägg till ' + diff + ' produkt' + (diff === 1 ? '' : 'er') + ' och spara <strong>' + nextTier.pct + '%</strong>';
          upsellEl.classList.remove('is-max');
          upsellEl.hidden = false;
        } else {
          upsellText.innerHTML = 'Grymt! Du sparar maximalt <strong>' + TIERS[TIERS.length - 1].pct + '%</strong>';
          upsellEl.classList.add('is-max');
          upsellEl.hidden = false;
        }
      }

      if (bumperEl && bumperCards.length) {
        var inCart = {};
        (cart.items || []).forEach(function (it) { inCart[String(it.product_id)] = true; });
        var shown = 0;
        for (var bi = 0; bi < bumperCards.length; bi++) {
          var card = bumperCards[bi];
          var pid = card.getAttribute('data-product-id');
          if (inCart[pid]) {
            card.hidden = true;
          } else {
            card.hidden = false;
            card.disabled = false;
            var plusReset = card.querySelector('.cdh-bumper-card-plus');
            if (plusReset) plusReset.textContent = '+';
            shown++;
          }
        }
        bumperEl.hidden = shown === 0;
      }
    }

    var _lastCart = null;

    function fetchCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); });
    }

    function gaCartItems(cart) {
      if (!cart || !cart.items) return [];
      return cart.items.map(function (item, i) {
        return {
          item_id: item.sku || String(item.id || ''),
          item_name: item.product_title || item.title,
          item_variant: (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '',
          price: (item.final_price || item.price) / 100,
          quantity: item.quantity,
          index: i
        };
      });
    }

    function updateFabCount(n) {
      var fab = document.querySelector('.cdh-fab');
      if (!fab) return;
      fab.setAttribute('data-count', n);
      var badge = fab.querySelector('[data-cdh-fab-count]');
      if (badge) badge.textContent = n > 99 ? '99+' : n;
    }

    function refresh(andOpen) {
      return fetchCart().then(function (cart) {
        _lastCart = cart;
        render(cart);
        updateFabCount(cart.item_count || 0);
        if (andOpen) open();
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          var count = bubble.querySelector('.cart-count-bubble span:first-child') || bubble.querySelector('.cart-count-bubble');
          if (count) count.textContent = cart.item_count;
        }
      });
    }

    itemsEl.addEventListener('click', function (e) {
      var line = e.target.closest('.cdh-item');
      if (!line) return;
      var key = line.getAttribute('data-cdh-line-key');
      if (!key) return;
      var qtyEl = line.querySelector('.cdh-qty-value');
      var curQty = parseInt(qtyEl ? qtyEl.textContent : '0', 10) || 0;
      var newQty = curQty;

      if (e.target.closest('[data-cdh-inc]')) newQty = curQty + 1;
      else if (e.target.closest('[data-cdh-dec]')) newQty = Math.max(0, curQty - 1);
      else if (e.target.closest('[data-cdh-remove]')) newQty = 0;
      else return;

      line.style.opacity = '.5';
      line.style.pointerEvents = 'none';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty }),
      }).then(function (r) { return r.json(); }).then(function (cart) {
        render(cart);
        updateFabCount(cart.item_count || 0);
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          var count = bubble.querySelector('.cart-count-bubble span:first-child') || bubble.querySelector('.cart-count-bubble');
          if (count) count.textContent = cart.item_count;
        }
      }).catch(function () {
        line.style.opacity = '';
        line.style.pointerEvents = '';
      });
    });

    if (bumperEl) {
      bumperEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cdh-bumper-add]');
        if (!btn) return;
        var vid = btn.getAttribute('data-variant-id');
        if (!vid) return;
        btn.disabled = true;
        var plus = btn.querySelector('.cdh-bumper-card-plus');
        var plusText = plus ? plus.textContent : '';
        if (plus) plus.textContent = '…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          return refresh(false);
        }).catch(function () {
          btn.disabled = false;
          if (plus) plus.textContent = plusText;
        });
      });
    }

    document.addEventListener('habitual:cart:add', function () { refresh(true); });
    document.addEventListener('habitual:cart:open', function () { refresh(true); });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-habitual-cart-open]');
      if (!trigger) return;
      e.preventDefault();
      refresh(true);
    });

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href$="/cart"], a[href*="/cart?"], a#cart-icon-bubble');
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      refresh(true);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cdh-checkout]')) return;
      if (window.gtag && _lastCart) {
        gtag('event', 'begin_checkout', {
          currency: 'SEK',
          value: (_lastCart.total_price || 0) / 100,
          items: gaCartItems(_lastCart)
        });
      }
    });

    // Defer the initial cart sync off the critical path.
    var deferInit = window.requestIdleCallback || function (cb) { return setTimeout(cb, 400); };
    deferInit(function () { refresh(false); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
